module.exports = __webpack_public_path__ + "static/media/non-stratified.c9627493.gif";